// Value is blank if it is null, undefined, an empty string, or a bunch of whitespace
const isBlank = val => val == null || (typeof val === 'string' && !val.trim());

export default isBlank;
